import { StackTypes, Text, VStack } from '@genial/components';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { CustomerDuckLabelProps, CustomerDuckLabel } from '../CustomerDuckLabel';
import { CustomerDuckMobileValueContainer } from '../CustomerDuckMobileValueContainer';
import { CustomerDuckValueProps, CustomerDuckValue } from '../CustomerDuckValue';

export type CustomerDuckInfoProps = Omit<CustomerDuckValueProps, 'value'> &
  CustomerDuckLabelProps & {
    label?: string;
    labelTooltip?: string;
    value: string | React.ReactNode;
    w?: StackTypes.Props['w'];
    minW?: StackTypes.Props['w'];
    loading?: boolean;
    loadingCustomElement?: React.ReactNode;
  };

export const CustomerDuckInfo: React.FC<CustomerDuckInfoProps> = ({
  value,
  mobileValue,
  valueRightIcon,
  label,
  labelTooltip,
  w,
  minW,
  loading,
  loadingCustomElement,
  copyValue,
  opaque,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const isValueString = typeof value === 'string';

  const renderValue = () => {
    if (loading) {
      return loadingCustomElement || <Text flex={1} maxW="1/2" isLoading />;
    }
    if (isValueString) {
      return (
        <CustomerDuckValue
          value={value}
          valueRightIcon={valueRightIcon}
          copyValue={copyValue}
          opaque={opaque}
        />
      );
    }
    return value;
  };

  const renderValueMobile = () => {
    if (loading) {
      return (
        loadingCustomElement || (
          <CustomerDuckMobileValueContainer>
            <Text flex={1} maxW="1/2" isLoading />
          </CustomerDuckMobileValueContainer>
        )
      );
    }
    if (isValueString || mobileValue) {
      return (
        <CustomerDuckMobileValueContainer>
          <CustomerDuckValue value={mobileValue || (value as string)} opaque={opaque} />
        </CustomerDuckMobileValueContainer>
      );
    }
    return value;
  };

  if (isMobile) {
    return (
      <VStack flex={1} space={label ? 'stack.quarck' : undefined}>
        <CustomerDuckLabel label={label} opaque={opaque} />
        {renderValueMobile()}
      </VStack>
    );
  }

  return (
    <VStack
      space={label ? 'stack.quarck' : undefined}
      w={w}
      maxW={w}
      minW={loading ? minW : undefined}>
      <CustomerDuckLabel label={label} labelTooltip={labelTooltip} opaque={opaque} />
      {renderValue()}
    </VStack>
  );
};
